export const INSIDER_HERO_COPY =
  'The HangarX Daily is the Insiders Daily Briefing for Leaders Shaping the Future of Flight. From advanced air mobility and aerospace innovation to capital policy and infrastructure, HXD connects the dots across the vertical economy so you make better decisions faster. Built for innovators, investors, and operators who can\u2019t afford to miss what\u2019s next.';

export const SUBSCRIBE_HERO_HEADLINE =
  'Subscribe to become sharper on aviation in five minutes';

export const PODCAST_PLATFORMS = [
  {
    id: 'spotify',
    label: 'Spotify',
    url: 'https://open.spotify.com/show/3rOII1WFicQEgcsLvt1p0Q',
  },
  {
    id: 'youtube',
    label: 'YouTube',
    url: 'https://www.youtube.com/@hangarxstudios',
  },
  {
    id: 'apple',
    label: 'Apple Podcasts',
    url: 'https://podcasts.apple.com/us/podcast/hangar-x-studios/id1790136775',
  },
];

export const STUDIOS_PODCAST = {
  eyebrow: 'Hangar X Studios',
  title: 'Weekly aerospace innovation podcast',
  description:
    'Hangar X Studios is a show for the aerospace community. Guests include thought leaders from the world of business, military, government and, of course, aerospace. We aim for content to be both entertaining and educational and we seek to uncover ideas on how aerospace is and will impact the world.',
  ctaLabel: 'Visit Hangar X Studios',
  watchUrl: 'https://hangarxstudios.com/',
  thumbnailUrl: '/images/hxd-subscribe-aircraft.png',
  embedUrl: 'https://www.youtube.com/embed/SPbJ1DMSkSI',
  platforms: PODCAST_PLATFORMS,
};
